import React, { useEffect } from "react";

export default function LoadAudioList({ mediaPath, srcList, onEnded, onCanPlayThrough, audioRef }) {
    srcList.forEach(() => {
        audioRef.push(React.createRef());
    });

    useEffect(() => {
        return () => {
        // cleanup: 모든 오디오 src 비우고 unload
        audioRef.forEach((ref) => {
            if (ref.current) {
            ref.current.pause();
            ref.current.removeAttribute("src");
            ref.current.load();
            }
        });
        };
    }, [audioRef]);

    return (
        <>
            {srcList.map((item, index) => (
                <audio
                    playsinline
                    webkit-playsinline
                    key={index}
                    ref={audioRef[index]}
                    src={(item.audio ? mediaPath + item.audio + "?v=" + Math.random() : '')}
                    onCanPlayThrough={() => onCanPlayThrough(index)}
                    onEnded={() => onEnded(index)}
                />
            ))}
        </>
    );
};